import React from "react";

/** Empty — editorial empty state. Calm, never apologetic. */
export function Empty({ title, hint, action, icon, testid }) {
  return (
    <div
      data-testid={testid}
      className="flex flex-col items-center justify-center gap-3 py-12 px-6 text-center"
    >
      {icon && <div className="text-[hsl(var(--foreground-muted))] opacity-60">{icon}</div>}
      <p className="font-serif text-xl text-[hsl(var(--foreground))]">{title}</p>
      {hint && (
        <p className="font-accent italic text-sm text-[hsl(var(--foreground-secondary))] max-w-sm">
          {hint}
        </p>
      )}
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}

/** Skeleton — calm loading bar; never a hard pulse. */
export function Skeleton({ className = "h-4 w-full" }) {
  return (
    <div
      className={`rounded bg-[hsl(var(--background-stone))]/60 animate-pulse ${className}`}
      aria-hidden
    />
  );
}
